import { render, staticRenderFns } from "./FirstPageLink.vue?vue&type=template&id=58a6799c&"
import script from "./FirstPageLink.vue?vue&type=script&lang=js&"
export * from "./FirstPageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports